import styled from "styled-components";

import {
	shine,
	slideInDown,
	slideInDownLarge,
	slideOutUp,
	slideOutUpLarge,
} from "@pages/casino/assets/styles/animations";

const animationTiming = "cubic-bezier(0.25, 0.46, 0.45, 0.94)";

export const LoadingOverlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 110%;
	background: linear-gradient(180deg, rgba(5, 5, 18, 1) 95%, rgba(25, 23, 38, 0) 100%);
	z-index: 99;

	animation: ${(props) => (props.loading ? slideInDown : slideOutUp)} 1s ${animationTiming} both;

	@media (min-height: 1000px) {
		animation: ${(props) => (props.loading ? slideInDownLarge : slideOutUpLarge)} 1.3s
			${animationTiming} both;
	}
`;

export const LoadingContainer = styled.div`
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 10000;

	img {
		width: 150px;
		height: 150px;
	}

	p {
		padding: 20px 0 0 13px;
		text-transform: uppercase;
		text-align: center;
		letter-spacing: 0.5px;
		margin-top: 20px;
		background: linear-gradient(
			to right,
			hsl(0, 0%, 50%) 0,
			hsl(0, 0%, 100%) 10%,
			hsl(0, 0%, 50%) 20%
		);
		background-size: 1000px 100%;
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
		background-clip: text;
		animation: ${shine} 10s infinite linear;
	}
`;
